import {ConfigProvider, Layout, Spin, theme, Typography,} from 'antd';
import PageHeader from '../../components/common/header/Header';
import {PageFooter} from '../../components/common/footer/Footer';
import {homeLogo, homeLogoWhite, xappHomeLogo,} from '../../../AppImageConst';
import RedirectToHomePage from '../../components/common/home/RedirectToHomePage';
import SideBarComp from '../../components/common/sidebar/SideBarComp';

import {useRef, useState} from 'react';
import './styles.scss';
import {faMoon} from "@fortawesome/free-solid-svg-icons/faMoon";
import {faSun} from "@fortawesome/free-solid-svg-icons/faSun";
import {isCustomer, isManagerUser, isRelationshipManagerUser} from "../../security/KeyclockConfig";
import {useHistory} from "react-router-dom";


const {Text} = Typography;
const {Content, Sider} = Layout;
const MainLayout = (props: any) => {
    const [collapsed, setCollapsed] = useState(true);
    const [isDarkMode, setIsDarkMode] = useState(false);
    const [isLogOutClicked, setIsLogOutClicked] = useState(false);
    const {defaultAlgorithm, darkAlgorithm} = theme;
    const history = useHistory();
    const sideBarRef = useRef();
    const handleClick = () => {
        setIsDarkMode((previousValue) => !previousValue);
    };
    const toggle = () => {
        setCollapsed(!collapsed);
    };

    const handleLogoClick = () => {
        let homeUrl =
            isCustomer() ? "/workflow/customer/dashboard"
            : isRelationshipManagerUser() ? "/workflow/admin/relationship-manager-dashboard"
                : isManagerUser() ? "/workflow/admin/manager-dashboard"
                    :  "/workflow/admin/dashboard";
        history.push(homeUrl)
        sideBarRef.current?.selectDashboard();
    };

    return (
        <ConfigProvider
            theme={

                {
                    token: {
                        //main logo
                        mainLogo: isDarkMode ? homeLogoWhite : homeLogo,
                        switchMode: isDarkMode,

                        //mode switcher
                        modeIcon: isDarkMode ? faSun : faMoon,
                        modeIconClass: isDarkMode ? 'dark-mode-enabled' : 'dark-mode-disabled',
                        modeToolTip: isDarkMode ? 'Disable Dark Mode' : 'Enable Dark Mode',

                        //footer background
                        footerBgColor: isDarkMode ? '#121212' : '#e8e8e8',
                        mainLayoutBGColor: isDarkMode ? '#121212' : '#e8e8e8',

                        colorPrimary: '#00959E',
                        siderCollapsed : collapsed

                    },
                    components: {
                        Button: {
                            colorPrimary: '#ff7400',
                            colorPrimaryActive: '#ff7400',
                            colorPrimaryHover: '#e66b00'
                        },

                        Layout: isDarkMode ? {
                            colorBgHeader: '#0e0e0e',
                        } : {
                            // colorBgBase: '#363db9',
                            colorBgHeader: '#ffffff',
                        },
                    },

                    algorithm: isDarkMode ? darkAlgorithm : defaultAlgorithm,
                }}>
            <Layout>
                {/*Sider*/}

                <Sider
                    className="side-bar"
                    // style={{backgroundColor: isDarkMode ? '#121212' : '#ffffff'}}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={toggle}
                >
                    <div className="side-bar-logo"
                         onClick={handleLogoClick}
                         style={{ cursor: 'pointer' }}
                         role="button">
                        <img className='logo-img' src={xappHomeLogo} alt="Logo"/>
                        {/*<Text className="logo--title">Xapp</Text>*/}
                    </div>
                    <SideBarComp ref={sideBarRef}/>
                </Sider>
                {/*End of  Sider*/}
                <Layout style={{backgroundColor: isDarkMode ? '#000000' : '#edefee'}}>
                    {/*Header*/}
                    <PageHeader collapsed={collapsed} toggle={toggle} logoutClicked={() => setIsLogOutClicked(true)}
                                changeTheme={handleClick}/>
                    {/*End of Header*/}
                    {/*Content*/}
                    <Spin spinning={isLogOutClicked} tip="Logging out...">
                        <Content className="site-layout-background"
                                 style={{backgroundColor: isDarkMode ? '#1f1f1f' : '#ffffff'}}>
                            <div>{props.children ? props.children : <RedirectToHomePage/>}</div>
                        </Content>
                    </Spin>

                    {/*End of Content*/}
                    {/*Footer*/}
                    <PageFooter/>
                    {/*    End of Footer*/}
                </Layout>
            </Layout>
        </ConfigProvider>

    );
};

export default MainLayout;
